var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"Home",staticClass:"Home"},[_c('HomeBanner'),_c('Showcases'),_c('Accelerator'),_c('div',{staticStyle:{"background-color":"#FBFDFF"}},[_c('SalesRampaign')],1),_c('NewsInfo'),_c('div',{staticStyle:{"background-color":"#FBFDFF"}},[_c('Cooperation')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }